import { env } from '@/config/env';

import catalan from './locales/ca.json';
import ee from './locales/ee/translation.json'; // Estonian
import en from './locales/en/translation.json'; // English
import french from './locales/fr.json';
import lt from './locales/lt/translation.json'; // Lithuanian
import rus from './locales/rus/translation.json'; // Russian
import spanish from './locales/sp.json';

export const LANGUAGES = {
  en: 'EN',
  es: 'ES',
  ee: 'EE',
  fr: 'FR',
  lt: 'LT',
  sl: 'SL',
  rus: 'RU',
  sp: 'SP', // Spanish
  ca: 'CA', // Catalan
} as const;

export const DEFAULT_LANGUAGE = en;

export type LanguageCodeType = keyof typeof LANGUAGES;
export type LanguageNameType = (typeof LANGUAGES)[LanguageCodeType];

export const enabledLanguages = (env.ENABLED_LANGUAGES?.split(',').filter(
  (lang) => Object.keys(LANGUAGES).includes(lang),
) as LanguageCodeType[]) || ['en'];

export const resources = {
  ca: { translation: catalan }, // Catalan
  en: { translation: en },
  es: { translation: ee }, // es is legacy alias for ee (Estonian)
  ee: { translation: ee }, // Estonian
  fr: { translation: french }, // French
  lt: { translation: lt },
  rus: { translation: rus },
  sp: { translation: spanish }, // Spanish
};

export type tKeysUnion = keyof typeof DEFAULT_LANGUAGE;
export type tKeysType = { [key in tKeysUnion]: tKeysUnion };

export const tKeys = Object.fromEntries(
  Object.keys(en).map((key) => [key, key]),
) as tKeysType;

export const getLanguageNameByCode = (
  code: LanguageCodeType,
): LanguageNameType => LANGUAGES[code] || 'EN';
